import { render, staticRenderFns } from "./AttachmentAvailabilityWrapper.vue?vue&type=template&id=14f2a49f&scoped=true"
import script from "./AttachmentAvailabilityWrapper.vue?vue&type=script&lang=ts"
export * from "./AttachmentAvailabilityWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f2a49f",
  null
  
)

export default component.exports